//frontend/src/components/visualiser/RouteVisualiser.jsx

import TrackLane from './TrackLane'
import React, { useMemo, useState } from 'react'
import Legend from '../common/Legend'
import {
  splitBusesByDirection,
  averageHeadway,
} from '@core/adapters/LondonVisualiserBuses'

export default function RouteVisualiser({ stops, buses, setSelectedStop, expectedArrivals }) {
  const [selectedVehicleId, setSelectedVehicleId] = useState(null)

  const { outbound: obBuses, inbound: ibBuses } = useMemo(
    () => splitBusesByDirection(buses),
    [buses]
  )

  const avgHeadwayOutbound = useMemo(() => averageHeadway(obBuses), [obBuses])
  const avgHeadwayInbound = useMemo(() => averageHeadway(ibBuses), [ibBuses])

  const handleSelectVehicle = (vehicleId) => {
    setSelectedVehicleId(prev => (prev === vehicleId ? null : vehicleId))
  }

  return (
    <div style={{ flex: 1, overflow: 'auto', padding: '28px 48px 40px' }}>
      {/* Legend Block */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 24, flexWrap: 'wrap' }}>
        {/* Icon legend — stop types, different shape from colour legend, stays inline */}
        {[
          { label: 'Standard Stop', el: <div style={{ width: 10, height: 10, background: 'var(--bg-surface)', border: '2.5px solid var(--text-muted)', borderRadius: '50%' }} /> },
          { label: 'Timing Point',  el: <div style={{ width: 11, height: 11, background: 'var(--ob-track)', border: '2px solid var(--bg-surface)', borderRadius: 2, transform: 'rotate(45deg)', boxShadow: '0 0 0 1.5px var(--ob-track)' }} /> },
          { label: 'Garage Run',    el: <div style={{ width: 9, height: 9, background: 'var(--bg-muted)', border: '2px solid var(--border)', borderRadius: '50%' }} /> },
        ].map(item => (
          <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 16, height: 16 }}>{item.el}</div>
            <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 }}>{item.label}</span>
          </div>
        ))}

        {/* Headway legend — shared component */}
        <div style={{ marginLeft: 'auto' }}>
          <Legend rows={[
            { label: 'Headway', items: [
              { color: 'var(--live-green)',   text: 'Large' },
              { color: 'var(--status-amber)', text: 'Normal' },
              { color: 'var(--live-red)',     text: 'Tight' },
            ]},
          ]} />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <TrackLane
          direction="outbound"
          stops={stops.outbound ?? []}
          buses={obBuses}
          trackColor="var(--ob-track)"
          label="Outbound"
          busAbove={true}
          onStopClick={setSelectedStop}
          avgHeadway={avgHeadwayOutbound}
          expectedArrivals={expectedArrivals}
          selectedVehicleId={selectedVehicleId}
          onSelectVehicle={handleSelectVehicle}
        />

        <TrackLane
          direction="inbound"
          stops={stops.inbound ?? []}
          buses={ibBuses}
          trackColor="var(--ib-track)"
          label="Inbound"
          busAbove={false}
          onStopClick={setSelectedStop}
          avgHeadway={avgHeadwayInbound}
          expectedArrivals={expectedArrivals}
          selectedVehicleId={selectedVehicleId}
          onSelectVehicle={handleSelectVehicle}
        />
      </div>
    </div>
  )
}